import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landingpage from "./pages/landing";
import 'bootstrap/dist/css/bootstrap.min.css';
import Login from "./dashboard/logindashroot";
import Dashboard from "./dashboard/dashboard";
import Navs from "./Component/navs";
import Pageservice from "./pag/service";
import PAgeContact from "./pag/pcontact";
import Pagabout from "./pag/about";
export default function App() {
  return (
    <BrowserRouter>
    <Navs></Navs>
      <Routes>
        <Route path="/" element={<Landingpage/>}> </Route>
        <Route path="/dashboardlogindash" element={<Login/>}></Route>
        <Route path="/dashboard-admain" element={<Dashboard/>}></Route>
        <Route path="/service" element={<Pageservice/>} />
        <Route path="/contact" element={<PAgeContact/>}/>
        <Route path="/about" element={<Pagabout/>}/>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
